import {
    post,
    get,
    put,
    del
} from "./http"
const message = {
    // 获得群发记录
    getrecord(param) {
        return get("client/message", param)
    },
    // 关键词列表
    getkeyword(param) {
        return get("client/keyword", param)
    },
    // 添加关键字
    addkeyword(param) {
        return post("client/keyword", param)
    },
    // 删除关键字
    delkeyword(id) {
        return del("client/keyword/" + id)
    },
    // 导出群发记录
    exportExcel(param) {
        return get("client/message/excel", param)
    },
    // 发送消息
    send(param) {
        return post("client/message", param)
    },
    // 5G视信发送消息
    sendPersonal(sendParams) {
        return post("client/message/createPersonal", sendParams)
    },
    // 通过分组id，获取分组人数
    getnum(id) {
        return get("client/address-book/group/" + id + "/contactor/num")
    },
    // 群发记录详情
    detail(params) {
        let { messageId } = params
        return get(`client/message/${messageId}`)
    },
    // 群发记录详情内发送列表
    sendList(params) {
        let { messageId } = params
        return get(`client/message/${messageId}/delivery-status`, params)
    }
}
export default message